import { useTheme } from 'contexts'
import React from 'react'
import { StyleSheet } from 'react-native'
import * as Yup from 'yup'

import { MyFormValues } from 'partials/EditProfileForm'

import { Box } from 'widgets/Box'
import { Field } from 'widgets/Field'
import { Form } from 'widgets/Form'
import { Text } from 'widgets/Text'

type UserBioFormProps = {
  initialValues: MyFormValues
  onSubmit: (values: any) => void
}

export const UserBioForm = ({ initialValues, onSubmit }: UserBioFormProps) => {
  const theme = useTheme()
  const computedStyles = StyleSheet.create({
    fieldStyles: {
      backgroundColor: 'transparent',
      borderWidth: 1,
      borderColor: theme.colors.greyLight,
      color: 'white',
    },
  })

  return (
    <>
      <Box testID='FormTitle' margin={{ horizontal: 'md' }}>
        <Text color='white'>Write your bio</Text>
      </Box>
      <Box testID='UserBioForm' margin={{ top: 'sm' }}>
        <Form
          initialValues={initialValues}
          onSubmit={onSubmit}
          submitCopy='NEXT'
          validationSchema={Yup.object().shape({
            bio: Yup.string().required('This field is required.'),
          })}
        >
          {({ errors: formikErrors, touched }: any) => {
            return (
              <>
                <Field
                  name='bio'
                  placeholder='150 characters'
                  placeholderTextColor={theme.colors.greyDarker}
                  type='textarea'
                  style={computedStyles.fieldStyles}
                />
              </>
            )
          }}
        </Form>
      </Box>
    </>
  )
}
